module.exports = __webpack_public_path__ + "img/zhang-gong.3b2f2cda.png";